export const config = {
    env: 'prod',
    api: 'https://t.xmk.app/api',
    pinLength: 4
}
